import React, {forwardRef, useImperativeHandle} from "react"
import {Button, Dialog, DialogHeader, DialogBody, DialogFooter, Input, Textarea, Alert} from "@material-tailwind/react"
import {createDataSpace} from "../../api/DataAPI"

export const CreateDataSpaceDialog = forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false)
  const [jsonFailAlert, setJsonFailAlert] = React.useState(false)
  const [jsonFailMessage, setJsonFailMessage] = React.useState('')
  const [dataspaceName, setDataspaceName] = React.useState('')
  const [metadata, setMetadata] = React.useState(JSON.stringify({
    "type": "jsonl",
    "x": "input_data_field",
    "y": "output_data_field",
    "model": {
      "type": "classification",
      "classes": 62
    }
  }, undefined, 4))

  const handleOpen = () => setOpen(!open)

  const handleJsonFormatting = () => {
    try {
      setMetadata(JSON.stringify(JSON.parse(metadata), undefined, 4))
    } catch (e) {
      setJsonFailAlert(true)
      setJsonFailMessage(e.toString())
    }
  }

  const handleCreateDataspace = () => {
    try {
      JSON.parse(metadata)
    } catch (e) {
      setJsonFailAlert(true)
      setJsonFailMessage(e.toString())
      return
    }

    createDataSpace(dataspaceName, metadata)
      .then(res => console.log(res))
      .catch(err => console.log(err))
      .finally(() => props.rerender())
  }

  useImperativeHandle(ref, () => ({
    openDialog() {
      handleOpen()
    }
  }))

  return (
    <>
      <Dialog
        open={open}
        handler={handleOpen}
        animate={{
          mount: {scale: 1, y: 0},
          unmount: {scale: 0.9, y: -100},
        }}
      >
        <DialogHeader>Create new dataspace</DialogHeader>

        <DialogBody>
          <div className={"pb-2"}>
            <Input label="DataSpace Name" onChange={(e) => setDataspaceName(e.target.value)}/>
          </div>
          <div>
            <Textarea className={"pt-2 min-h-[250px]"}
                      label="Metadata"
                      value={metadata}
                      onChange={(e) => setMetadata(e.target.value)}/>
          </div>
        </DialogBody>

        <Alert
          className={"absolute w-3/4 mx-auto left-0 right-0 my-24"}
          open={jsonFailAlert}
          onClose={() => setJsonFailAlert(false)}
          animate={{
            mount: {y: 0},
            unmount: {y: 100},
          }}
        >
          {jsonFailMessage}
        </Alert>
        <DialogFooter className={"pt-0"}>
          <Button
            className="mr-2"
            variant="gradient"
            color="amber"
            onClick={handleJsonFormatting}>
            <span>JSON Formatting</span>
          </Button>
          <Button
            className="mr-2"
            variant="outlined"
            color="red"
            onClick={handleOpen}
          >
            <span>Cancel</span>
          </Button>
          <Button variant="gradient" color="green" onClick={handleCreateDataspace}>
            <span>Confirm</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  )

})
